import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { axiosInstance } from '../config';
import './PremiumCheckout.css';

export default function PremiumSuccess() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const userId = localStorage.getItem('userID');
        if (!userId) return;
        const res = await axiosInstance.get('/premium/status');
        setStatus(res.data);
      } catch {
        // ignore
      }
    };
    fetchStatus();
  }, []);

  const isActive = status?.status === 'active';

  return (
    <div className="premium-checkout-page">
      <div className="premium-checkout-card premium-success-card">
        <div className="premium-success-badge">
          {isActive ? 'SUCCESS' : 'PENDING'}
        </div>
        <h1>{isActive ? 'Welcome to Premium!' : 'Payment received'}</h1>
        <p className="premium-success-message">
          {isActive
            ? `Your ${status.plan === 'yearly' ? '12-month' : 'monthly'} premium access is now active. Enjoy all premium features!`
            : 'Your payment has been submitted. Premium access will be activated within a few minutes once PayFast confirms the transaction.'}
        </p>

        {isActive && status.subscriptionEndDate && (
          <p className="premium-success-renewal">
            Access valid until:{' '}
            <strong>{new Date(status.subscriptionEndDate).toLocaleDateString('en-ZA')}</strong>
          </p>
        )}

        <Link
          to="/"
          className="premium-checkout-submit premium-success-primary-link"
        >
          Start exploring
        </Link>
        <Link to="/premium" className="premium-checkout-back premium-success-back-link">
          Back to Premium
        </Link>
      </div>
    </div>
  );
}
